module.exports = __webpack_public_path__ + "img/image_105.bf2aa718.png";